import { appContent } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="bg-gradient-to-br from-primary-500 to-accent-500 rounded-3xl p-8 md:p-14 text-center relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/4 blur-2xl"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/10 rounded-full translate-y-1/3 -translate-x-1/4 blur-2xl"></div>

          <div className="relative z-10">
            <div className="w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-white/20 backdrop-blur flex items-center justify-center mx-auto mb-5">
              <i className="ri-smartphone-line text-white text-3xl md:text-4xl w-8 h-8 md:w-10 md:h-10 flex items-center justify-center"></i>
            </div>
            <h2 className="font-heading text-2xl md:text-4xl text-background-50 mb-4">{appContent.title}</h2>
            <p className="text-sm md:text-base text-background-50/80 max-w-lg mx-auto mb-8">{appContent.description}</p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 mb-8">
              {appContent.steps.map((step, i) => (
                <div key={i} className="flex items-center gap-2 bg-white/15 backdrop-blur rounded-full px-4 py-2.5">
                  <span className="w-6 h-6 rounded-full bg-white text-primary-500 text-xs font-bold flex items-center justify-center flex-shrink-0">{i + 1}</span>
                  <span className="text-sm text-white font-medium whitespace-nowrap">{step}</span>
                </div>
              ))}
            </div>

            <a
              href="#hero"
              className="inline-flex items-center gap-2 bg-white text-primary-500 px-8 py-3.5 rounded-full text-sm font-semibold hover:bg-background-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-line w-4 h-4 flex items-center justify-center"></i>
              立即体验
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}